import BasePopup from '../Base/BasePopup';

export default BasePopup;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-tree-select/es/Popup/MultiplePopup.js
// module id = 1641
// module chunks = 0